<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QZHEtq/tc-custom/9781452146256.jpg?1718078716313" alt="This image is the cover for the book Legends of Texas Barbecue Cookbook"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Legends of Texas Barbecue Cookbook
      </h1>
      <p class="bookDescription body article font2">
        <b>“[A] collection of barbecue memoirs, trivia and history . . . Walsh interviews the top pit bosses across the state and shares their secrets.” —<i>Publishers Weekly</i></b><br/><br/>If barbecue in Texas is a religion, this book is its bible. Originally published only in print in 2002, this revised and updated edition explores all the new and exciting developments from the Lone Star State’s evolving barbecue scene. The one hundred recipes include thirty-two brand-new ones such as Smoke-Braised Beef Ribs and an extremely tender version of Pulled Pork. Profiles on legendary pitmasters like Aaron Franklin are featured alongside archival photography covering more than one hundred years of barbecue history. Including the basic tools required to get started, secrets and methods from the state’s masters, and step-by-step directions for barbecuing every cut of meat imaginable, this comprehensive book presents all the info needed to fire up the grill and barbecue Texas-style.<br/><br/><b>“In 2002, Robb Walsh’s <i>Legends of Texas Barbecue Cookbook</i> hit the sweet spot for lovers of smoked meat. The book was part travelogue, part instruction manual, with a side of history thrown in . . . If your old copy is worn, tattered and splashed, it’s time to trade up. If you are late to the barbecue and don’t know the likes of Bryan Bracewell, Vencil Mares and Lorenzo Vences, consider it an investment in your education.” —<i>The Dallas Morning News</i></b><br/><br/><b>“Robb Walsh has been there to help shape and document the evolution of Texas barbecue. This new edition is a must-have.” —Aaron Franklin, James Beard Award–winning pitmaster</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robb Walsh
      </h2>
      
      <p class="authorDescription body article">Robb Walsh , co-author of Nuevo Tex-Mex, is a culinary adventurer hailed as the "Indiana Jones of food writers." A multiple James Beard Award winner, he is currently the restaurant critic of the Houston Press and a commentator for National Public Radio.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?77cd364a